import moment from 'moment-timezone';
export const convertTo24HourFormat = (unformattedTime) => {
  if (!unformattedTime) {
    return unformattedTime;
  }
  
  const [time, period] = unformattedTime.split(' ');
  const [hours, minutes] = time.split(':');
  let hour24 = parseInt(hours);
  
  if (period === 'PM' && hour24 !== 12) {
    hour24 += 12;
  } else if (period === 'AM' && hour24 === 12) {
    hour24 = 0;
  }
  return `${hour24.toString().padStart(2, '0')}:${minutes}`;
};

export const convertTo12HourFormat = (time24) => {
  if (!time24) {
    return time24;
  }

  const [hours, minutes] = time24.split(':');
  const hour = parseInt(hours);
  const period = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  
  return `${hour12}:${minutes} ${period}`;
};

export const formatDateTime = (date, timezone = 'UTC', format = 'M/D/YY h:mm A') => {
  if (!date) return '-';
  return moment.utc(date).tz(timezone || 'UTC').format(format);
};

export const calculateAge = (birthday) => {
  if (!birthday) return null;
  
  const today = new Date();
  const birthDate = new Date(birthday);
  
  // Check if birthday is valid
  if (isNaN(birthDate.getTime())) return null;
  
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  // If birthday hasn't occurred yet this year, subtract one year
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
}; 